import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";

interface IconProps {
  /** A Lucide icon component */
  icon: LucideIcon;
  /** Size of the icon wrapper */
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  /** Color — defaults to currentColor */
  className?: string;
  /** Accessible label — if omitted, icon is decorative (aria-hidden) */
  label?: string;
}

const SIZE_CLASS: Record<string, string> = {
  xs: "size-3",
  sm: "size-4",
  md: "size-5",
  lg: "size-6",
  xl: "size-8",
};

function Icon({ icon: IconComponent, size = "md", className, label }: IconProps) {
  return (
    <IconComponent
      className={cn(SIZE_CLASS[size], "shrink-0", className)}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? "img" : undefined}
    />
  );
}

export { Icon };
export type { IconProps };
